/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';

@Component({
    selector: 'sag-ui-filedrop',
    template: `
        <div sag-ui-filedrop-zone [disabled]="disabled" style="height: 250px;">
            <ng-content></ng-content>
            <input
                type="file"
                [id]="id"
                [disabled]="disabled"
                [required]="required"
                [multiple]="multiple"
                [attr.accept]="accept"
                (change)="onChange($event)"
                (click)="click.emit($event)"
                (focus)="focus.emit($event)"
                (blur)="onTouched(); blur.emit($event)"
                sag-ui-filedrop
            />
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileDropComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FileDropComponent),
            multi: true
        }
    ]
})
export class FileDropComponent implements ControlValueAccessor, Validator {
    @Input() id = this.randomId();
    @Input() disabled = false;
    @Input() required = false;
    @Input() accept = '*/*';
    @Input() multiple = false;

    @Output() change = new EventEmitter<FileList | null>();
    @Output() click = new EventEmitter<Event>();
    @Output() focus = new EventEmitter<Event>();
    @Output() blur = new EventEmitter<Event>();

    private files: FileList | null = null;

    onChangeEvent = (_: any) => {};
    onTouched = () => {};

    writeValue(files: FileList | null): void {
        this.files = files;
    }

    registerOnChange(fn: any): void {
        this.onChangeEvent = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onChange(event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        const input = event.target as HTMLInputElement;
        this.files = input.files;
        this.onChangeEvent(this.files);
        this.change.emit(this.files);
    }

    validate(_: AbstractControl): ValidationErrors | null {
        return this.required && !this.files ? { required: true } : null;
    }

    private randomId(): string {
        return Math.random().toString(36).substring(2);
    }
}
